export class ProgressBarStorageCardModel {
  declare public storageCapacityLimit: string;
  declare public storageUsage: string;
  declare public storageUsagePercentage: number;
  declare public warnFlag: boolean;
}
